import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AuthService } from "../../auth/auth.service";
import { UserModel } from "../../model/user.model";
import { SuccessSnackbarComponent } from "../success-snackbar/success-snackbar.component";

@Component({
  selector: "app-trainers-edit-dialog",
  templateUrl: "./trainers-edit-dialog.component.html",
  styleUrls: ["./trainers-edit-dialog.component.css"],
})
export class TrainersEditDialogComponent implements OnInit {
  mItems: UserModel[];
  errorMessage: string = "";
  isLoading: boolean = true;

  durationInSeconds = 1;

  selectedItem: UserModel;

  constructor(
    private fb: FormBuilder,
    private mApiService: AuthService,
    private _snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<TrainersEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.selectedItem = this.data;
  }

  getItemsList() {
    let id = "1A9810A1-EE07-44C9-9475-5E4BD7EEF56D"; // default id used to select all trainers

    this.mItems = [];
    this.isLoading = true;

    this.mApiService.getTrainers(id).subscribe(
      (p) => (this.mItems = p),
      (e) => (this.errorMessage = e),
      () => (this.isLoading = false)
    );
  }

  onlyNumberKey(event) {
    let ASCIICode = event.which ? event.which : event.keyCode;
    if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) return false;
    return true;
  }

  saveEditItem() {
    this.mApiService.updateUserTrainer(this.selectedItem).subscribe(
      (p) => {
        //  this.editModal.close('1');
        this.selectedItem = new UserModel();
        this.getItemsList();

        this.dialogRef.close();

        this._snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: this.durationInSeconds * 1000,
        });
      },
      (e) => (this.errorMessage = e),
      () => (this.isLoading = false)
    );
  }
}
